let NotificationService = function (Restangular) {
  const Service = Restangular.all("admin/notification");

  let count = (query) => {
    query = query || {};
    query.deleted_at = "null";
    query.is_public = 1;
    return Service.customGET("count", query);
  };

  let save = (resource) => {
    if (resource.save) {
      const id = resource.id
      delete resource.id;
      return Service.customPOST(resource, `${id}`);
    } else {
      return Service.post(resource);
    }
  };

  let index = (query) => {
    query = query || {};
    query.deleted_at = "null";
    query.is_public = 1;
    return Service.getList(query);
  };

  let load = (query) => {
    query = query || {};
    query.deleted_at = "null";
    query.is_public = 1;
    return new Promise((resolve, reject) => {
      count(query)
        .then((response) => {
          let count = response[0];
          index(query)
            .then((data) => {
              resolve({ count, data });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  let show = (id) => {
    return Service.get(id);
  };

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return Service.customDELETE(resource.id);
  };

  return { index, load, save, show, destroy };
};

NotificationService.$inject = ["Restangular"];

export default NotificationService;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification.service.js